import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { withSystem, withoutSystem } from '../../data/content';
export function BenefitSection() {
  return <section aria-labelledby="benefit-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-52" data-mp="eag05v8nua92">
      <div className="mx-auto max-w-5xl" data-id="element-53" data-mp="ibt8cbz86pj5">
        <SectionHeading id="benefit-heading" title={<>
              Spend Less Time Creating Materials. <Accent data-id="element-55" data-mp="1b0756oekvft4">More Time Actually Teaching.</Accent>
            </>} body="Your expertise should go into teaching your students, not repeatedly rebuilding lesson plans and practice materials. Nail Educator Ready™ gives you a starting structure you can use alongside your own professional knowledge, demonstrations and preferred product systems." data-id="element-54" data-mp="i8ngwq34jbk9" />

        <div className="mt-14 grid items-stretch gap-6 md:grid-cols-[0.9fr_1.1fr]" data-id="element-56" data-mp="3mp86s8xpp59z">
          <div className="rounded-[20px] border border-brand-charcoal/12 px-6 py-8 sm:px-8" data-id="element-57" data-mp="3mmvf3425jgjq">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-58" data-mp="8t61undu8wy">
              Without the System
            </p>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-59" data-mp="a5o286w6nx82">
              {withoutSystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/55" data-id="element-60" data-mp="550ebu393wi2">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-brand-charcoal/35" strokeWidth={2} aria-hidden="true" data-id="element-61" data-mp="j3rox6iwn01g" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] bg-brand-cta-dark px-6 py-8 text-white shadow-[0_30px_60px_-30px_rgba(72,103,70,0.7)] sm:px-8" data-id="element-62" data-mp="sx8h663e8730">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-white/75" data-id="element-63" data-mp="11vkd8nn13x2u">
              With Nail Educator Ready™
            </p>
            <ul className="mt-6 grid gap-x-6 gap-y-3.5 sm:grid-cols-2" role="list" data-id="element-64" data-mp="xsnrwp63tmv7">
              {withSystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-white" data-id="element-65" data-mp="19w8lh4u5vt5t">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-66" data-mp="1evl4fehwwg34">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-67" data-mp="1jncxbvojixwf" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-12 text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-68" data-mp="1spceqp3gw3zw">
          Your knowledge + <Accent data-id="element-69" data-mp="22lpbjvub6xyv">a ready teaching structure.</Accent>
        </p>
      </div>
    </section>;
}